import { useEffect, useState } from "react";
import "../style/userCardStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getUserCard } from "../store/actions/pcardAction";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import BussinesCard from "../components/BussinesCard";
import Loading from "../components/Loading";
function UserCard() {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => state.bussinesCard);
  const [userCard, setUserCard] = useState({});
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const UUID = searchParams.get("user");
  const branch = searchParams.get("branch");
  useEffect(() => {
    const payload = {
      UUID,
      branch,
    };
    dispatch(getUserCard(payload))
      .unwrap()
      .then((res) => setUserCard(res))
      .catch((err) => message.error(err, 4));
  }, [UUID, branch, dispatch]);

  if (isLoading) {
   return <Loading/>
  }

  return (
    <div className="user_card">
      <BussinesCard userCard={userCard} translate={t} />
    </div>
  );
}

export default UserCard;
